import { useAtom } from 'jotai';
import React from 'react';
import Select from 'react-select';
import styles from 'views/Admin/Dashboard/styles.module.css';

import { colorStyles, SeverityOption } from './config';
import { getChartLegendColor } from '../../helper';
import { Severity } from '../../types';

type Props = {
  severityFiltersAtom: any;
  placeholderText?: string;
};

const toSeverityOption = (severity: Severity) => {
  const key = Severity[severity];
  return { value: key, label: key, color: getChartLegendColor(Severity[key]) };
};

const SEVERITY_OPTIONS: SeverityOption[] = Object.keys(Severity).map((key) => {
  return toSeverityOption(Severity[key]);
});

const SeverityFilterDropdown = ({
  severityFiltersAtom,
  placeholderText = 'Severity',
}: Props) => {
  const [severityFilters, setSeverityFilters] = useAtom(severityFiltersAtom);

  function handleOnSeveritySelect(selectedList) {
    const all = Severity[Severity.All];
    let selectedSeverities = selectedList?.map((x) => Severity[x.value]) || [];
    // if all is selected
    if (selectedSeverities.includes(all)) {
      //  if it was not previously selected, then select all
      if (Array.isArray(severityFilters) && severityFilters.length !== 5) {
        selectedSeverities = Object.keys(Severity).map((x) => x);
      }
      // if all was previously selected, and another option is selected now
      // then unselect all option
      else {
        if (Array.isArray(severityFilters) && severityFilters.length >= 5)
          selectedSeverities = selectedSeverities.filter((x) => x !== all);
      }
    }

    // filter out the all option
    selectedSeverities = selectedSeverities.filter((x) => x !== all);

    setSeverityFilters(selectedSeverities);
  }

  return (
    <Select
      className={`custom-360-dropdown ${styles.mw250} px-2`}
      options={SEVERITY_OPTIONS}
      isMulti={true}
      // allowSelectAll={true}
      value={
        Array.isArray(severityFilters)
          ? severityFilters.map((x) => toSeverityOption(Severity[x]))
          : []
      }
      onChange={handleOnSeveritySelect}
      hideSelectedOptions={true}
      controlShouldRenderValue={true}
      styles={colorStyles}
      aria-label="interval"
      aria-describedby="intervalLabel"
      placeholder={placeholderText}
      closeMenuOnSelect={false}
    />
  );
};

export default SeverityFilterDropdown;
